import React, { useRef, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import { AppContext } from '../../UI/contexts';
import { isAuthRol } from '../../../Utils/helpers';
import { getDropdownConfigs } from './items';

function ToolbarItems() {
  const dropdownRefs = useRef({});
  const navigate = useNavigate();
  const [, setOpenDropdown] = useState(null);

  const { user } = useContext(AppContext);
  const { roles } = user || {};
  const role = isAuthRol(roles);

  const dropdownConfigs = getDropdownConfigs(role);

  const handleDropdownChange = (e) => {
    navigate(e.value);
    setOpenDropdown(null);
  };

  const handleDropdownShow = (key) => {
    Object.entries(dropdownRefs.current).forEach(([k, ref]) => {
      if (k !== key && ref) ref.hide();
    });
    setOpenDropdown(key);
  };

  const itemTemplate = (option) => {
    return (
      <div className='dropdown-item-template'>
        <i className={option.icon} />
        <span>{option.label}</span>
      </div>
    );
  };

  return (
    <div className='control-section toolbar-menu-container'>
      <div className='toolbar-nav-items'>
        {Object.entries(dropdownConfigs)
          .filter(([key]) => key !== 'scopes' || role !== 'user')
          .filter(([key]) => key !== 'airProducts' || role === 'jenkins')
          .map(([key, config]) => (
            <Dropdown
              key={key}
              ref={(el) => (dropdownRefs.current[key] = el)}
              options={config.items}
              onChange={handleDropdownChange}
              placeholder={config.placeholder}
              itemTemplate={itemTemplate}
              className='toolbar-dropdown'
              scrollHeight='none'
              onShow={() => handleDropdownShow(key)}
              onHide={() => setOpenDropdown(null)}
            />
          ))}
      </div>
    </div>
  );
}

export default ToolbarItems;
